export default {
  path: '/staff-management',
  name: 'staffmanagement',
  meta: {
    title: 'Staff Management',
    icon: 'Labor Management',
  },
  redirect: '/wms-labormanagement/organization-structure',
  children: [
    {
      path: 'organization-structure',
      name: 'staffmanagement.organizationstructure',
      meta: {
        title: 'Organization Structure',
      },
      redirect: '/wms-labormanagement/organization-structure',
    },
    {
      path: 'staff-profile',
      name: 'staffmanagement.opsprofile',
      meta: {
        title: 'Staff Profile',
      },
      redirect: '/wms-labormanagement/staff-profile',
    },
    {
      path: 'position-list',
      name: 'staffmanagement.position',
      meta: {
        title: 'Position Management',
      },
      redirect: '/wms-labormanagement/position/list',
    },
  ],
};
